import { defineComponent, computed } from 'vue';
import { Context, FieldInputType } from '@getaccept/editor-lib-new';
import InputSet from './InputSet.vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';
export default defineComponent({
    name: 'EditorNodeForm',
    components: {
        InputSet,
        EditorNodeWrapper,
    },
    props: {
        node: { type: Object, default: () => ({}) },
        context: { type: String, default: () => Context.Document },
        mergeValues: { type: Object, required: true },
        isMobile: { type: Boolean },
        blockWidthClass: {
            type: String,
            default: null,
        },
        focusedRequiredId: { type: String, default: '' },
        sender: {
            type: Object,
            default: () => ({}),
        },
        recipient: {
            type: Object,
            default: () => ({}),
        },
        recipientInput: { type: Array, required: true },
        isPdfViewer: { type: Boolean, default: false },
        updatingInputs: { type: Array, required: true },
        failedInputUpdates: { type: Array, required: true },
    },
    emits: ['observe-node-visibility', 'update-input-value'],
    setup(props, { emit }) {
        const updateInputValue = (id, value) => {
            emit('update-input-value', { id, value });
        };
        const getFieldById = (id) => props.node.fields.find(field => field.id === id);
        const inputSets = computed(() => props.node.inputFieldSets.map(inputSet => inputSet.ids.map(getFieldById)));
        return {
            FieldInputType,
            updateInputValue,
            inputSets,
            getFieldById,
        };
    },
});
